// Unpublished Work © 2021-2024 Deere & Company.

export const FULFILLED = 'fulfilled';
export const REJECTED = 'rejected';
